<template>
	<div class="main-load">
		<d-card id="change-password-card" class="mx-auto w-65">
			<d-card-img src="./hp-banner.jpg" class="mt-5" fluid />
			<d-card-body title="Change Password" class="change-password-card">
				<d-form @submit="changePassword">
					<d-alert theme="danger" :show="error.length">{{ error }}</d-alert>
					<d-alert theme="success" :show="success.length">{{ success }}</d-alert>
					<div class="form-group">
						<label for="password" class="sr-only">Password</label>
						<d-input
							id="password"
							name="password"
							type="password"
							v-model="password"
							placeholder="Password"
							required
						/>
					</div>
					<div class="form-group">
						<label for="newPassword" class="sr-only">New Password</label>
						<d-input
							autofocus
							id="newPassword"
							name="newPassword"
							type="password"
							v-model="newPassword"
							placeholder="New Password"
							required
						/>
					</div>
					<div class="form-group">
						<label for="confirmPassword" class="sr-only">Confirm Password</label>
						<d-input
							autofocus
							id="confirmPassword"
							name="confirmPassword"
							type="password"
							v-model="confirmPassword"
							placeholder="Confirm Password"
							required
						/>
					</div>
					<div v-show="showLoading" class="loading">
						<Spinner class="spinner" size="medium"></Spinner>
					</div>
					<div v-show="!showLoading" class="loading">
						<d-button theme="primary">Change Password</d-button>
					</div>
				</d-form>
			</d-card-body>
		</d-card>
	</div>
</template>

<script>
import AuthService from "@/services/AuthService";
import Spinner from 'vue-simple-spinner'

export default {
	name: "SetCookie",
	components: {
		Spinner
	},
	data() {
		return {
			showLoading: false,
			password: "",
			newPassword: "",
			confirmPassword: "",
			errorMessage: "",
			error: "",
			success: ""
		};
	},
	methods: {
        async changePassword(e) {
            e.preventDefault();
            this.error = "";
            this.success = "";
			this.showLoading = true;

			if(this.newPassword != this.confirmPassword){
				this.error = "New password and confirm password does not match.";
				return false;
			}

            try {
                await AuthService.changePassword({
                    password: this.password,
                    newPassword: this.newPassword,
                    confirmPassword: this.confirmPassword
                });
                this.success = "Successfully changed the password.";
				this.password = "";
				this.newPassword = "";
				this.confirmPassword = "";
            } catch (error) {
                this.error = "Incorrect password entered.";
            } finally {
				this.showLoading = false;
			}
        }
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

	.main-load {
		margin: 0;
		position: absolute;
		top: 50%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%);
		width: 100%;

		#change-password-card {
			max-width: 600px;

			.change-password-card {
				padding-top: 10px;

				.spinner {
					padding-top: 10px;
				}
			}
		}
	}
</style>
